import { axiosInstance } from "@/config/axiosInstance";

export const uploadLeadsAsAdmin = (adminKey: string) => async (file: File) => {
  const formData = new FormData();
  formData.append("file", file);

  return axiosInstance
    .post("/lead/upload/admin", formData, {
      headers: {
        authorization: `Bearer ${adminKey}`,
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => response.data);
};

// ? Delete Leads Action
export const deleteLeadsAsAdmin =
  (adminKey: string) => (data: { leads: string[] }) =>
    axiosInstance
      .post(
        `/lead/delete/admin`,
        { leads: data?.leads },
        {
          headers: {
            authorization: `Bearer ${adminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);
